import { useQuery } from '@tanstack/react-query';

import { featureFlagsQueryOptions } from './featureFlagsQuery';
import type { FeatureFlagName } from './flagNames';

/** Subscribes to the shared feature-flags query (fetch + refresh + cache). */
export function useFeatureFlags() {
  return useQuery(featureFlagsQueryOptions);
}

/**
 * React hook: returns whether a feature flag is on. Reactive — re-renders when
 * the flag value changes. Defaults to `false` while loading or if the endpoint
 * is unreachable.
 *
 * For code that runs outside React render (module scope, route config,
 * imperative handlers), use `isFeatureEnabled` instead.
 */
export function useFeatureFlag(name: FeatureFlagName): boolean {
  const { data } = useFeatureFlags();
  return Boolean(data?.[name]);
}
